export default "__VITE_ASSET__8796d182__"